/** LinkedIn brand glyph (lucide v1 dropped brand icons). Inherits currentColor. */
export function IgGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="5" cy="5" r="2" fill="currentColor" />
      <path d="M3 9h4v12H3V9Zm7 0h4v1.6c.7-1.2 1.9-2 3.5-2C21 8.6 22 10.9 22 14v7h-4v-6.4c0-1.6-.3-2.7-1.8-2.7-1.6 0-2.2 1.1-2.2 2.7V21h-4V9Z" fill="currentColor" />
    </svg>
  );
}

/** Puzzle-piece-free "extension" glyph: a browser window with a plug dot. */
export function ExtensionGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M2.5 8.5h19" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="5.6" cy="6.25" r=".9" fill="currentColor" />
      <circle cx="8.4" cy="6.25" r=".9" fill="currentColor" />
      <path d="M9 14.5h6M12 11.5v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
